module.exports = __webpack_public_path__ + "img/chronic_condition.67c68271.svg";